export default "__VITE_ASSET__D9BP2qzo__"